/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-01",
    versionChannel: "nightly",
    buildDate: "2025-06-01T00:08:16.169Z",
    commitHash: "b2590cb29efce3e9d76edf9579f0b9efa4d9ae52",
};
